module.exports = {
  FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_REQUEST: 'FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_REQUEST',
  FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_SUCCESS: 'FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_SUCCESS',
  FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_FAILURE: 'FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_FAILURE',
  FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_REQUEST: 'FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_REQUEST',
  FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_SUCCESS: 'FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_SUCCESS',
  FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_FAILURE: 'FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_FAILURE',
};
